module.exports = __webpack_public_path__ + "img/line.3fe1ede7.svg";